// extracted by mini-css-extract-plugin
    if(module.hot) {
      // 1748427828395
      var cssReload = require("D:/123/river-web/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"publicPath":"../../","locals":false});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);
    }
  